import { render, staticRenderFns } from "./ReferralViewInfo.vue?vue&type=template&id=06c75bcc&"
import script from "./ReferralViewInfo.vue?vue&type=script&lang=js&"
export * from "./ReferralViewInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports